import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoolean = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 12,
	viewBox: "0 0 17 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M0 3.28125C0 3.85166 0.46084 4.3125 1.03125 4.3125H10.4897C10.377 3.99023 10.3125 3.64219 10.3125 3.28125C10.3125 3.23613 10.3125 3.19102 10.3157 3.1459C10.3189 3.10078 10.3189 3.05566 10.3254 3.01377C10.3318 2.92676 10.3447 2.83652 10.3576 2.75273C10.3866 2.58193 10.4317 2.41436 10.4897 2.25322L1.03125 2.25C0.46084 2.25 0 2.71084 0 3.28125ZM6.01025 8.4375C6.12305 8.75977 6.1875 9.10781 6.1875 9.46875C6.1875 9.51387 6.1875 9.55898 6.18428 9.6041C6.18105 9.64922 6.18106 9.69434 6.17461 9.73623C6.16816 9.82324 6.15527 9.91348 6.14238 9.99727C6.11338 10.1681 6.06826 10.3356 6.01025 10.4968L15.4688 10.5C16.0392 10.5 16.5 10.0392 16.5 9.46875C16.5 8.89834 16.0392 8.4375 15.4688 8.4375H6.01025Z",
			fill: "url(#paint0_linear_7940_104457)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4062 4C13.1327 4 12.8704 3.89464 12.677 3.70711C12.4836 3.51957 12.375 3.26522 12.375 3C12.375 2.73478 12.4836 2.48043 12.677 2.29289C12.8704 2.10536 13.1327 2 13.4062 2C13.6798 2 13.9421 2.10536 14.1355 2.29289C14.3289 2.48043 14.4375 2.73478 14.4375 3C14.4375 3.26522 14.3289 3.51957 14.1355 3.70711C13.9421 3.89464 13.6798 4 13.4062 4ZM13.4062 0C12.5857 0 11.7988 0.316071 11.2186 0.87868C10.6384 1.44129 10.3125 2.20435 10.3125 3C10.3125 3.79565 10.6384 4.55871 11.2186 5.12132C11.7988 5.68393 12.5857 6 13.4062 6C14.2268 6 15.0137 5.68393 15.5939 5.12132C16.1741 4.55871 16.5 3.79565 16.5 3C16.5 2.20435 16.1741 1.44129 15.5939 0.87868C15.0137 0.316071 14.2268 0 13.4062 0ZM3.09375 10C2.82025 10 2.55794 9.89464 2.36455 9.70711C2.17115 9.51957 2.0625 9.26522 2.0625 9C2.0625 8.73478 2.17115 8.48043 2.36455 8.29289C2.55794 8.10536 2.82025 8 3.09375 8C3.36725 8 3.62956 8.10536 3.82295 8.29289C4.01635 8.48043 4.125 8.73478 4.125 9C4.125 9.26522 4.01635 9.51957 3.82295 9.70711C3.62956 9.89464 3.36725 10 3.09375 10ZM3.09375 6C2.68747 6 2.28517 6.0776 1.90982 6.22836C1.53447 6.37913 1.19342 6.6001 0.906138 6.87868C0.618857 7.15726 0.390973 7.48797 0.235498 7.85195C0.0800222 8.21593 0 8.60603 0 9C0 9.39397 0.0800222 9.78407 0.235498 10.1481C0.390973 10.512 0.618857 10.8427 0.906138 11.1213C1.19342 11.3999 1.53447 11.6209 1.90982 11.7716C2.28517 11.9224 2.68747 12 3.09375 12C3.50003 12 3.90233 11.9224 4.27768 11.7716C4.65303 11.6209 4.99408 11.3999 5.28136 11.1213C5.56864 10.8427 5.79653 10.512 5.952 10.1481C6.10748 9.78407 6.1875 9.39397 6.1875 9C6.1875 8.60603 6.10748 8.21593 5.952 7.85195C5.79653 7.48797 5.56864 7.15726 5.28136 6.87868C4.99408 6.6001 4.65303 6.37913 4.27768 6.22836C3.90233 6.0776 3.50003 6 3.09375 6Z",
			fill: "url(#paint1_linear_7940_104457)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_7940_104457",
			x1: 0,
			y1: 6.375,
			x2: 16.5,
			y2: 6.375,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1D7FB6" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#01D5AB"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_7940_104457",
			x1: 0,
			y1: 6,
			x2: 16.5,
			y2: 6,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1D7FB6" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#01D5AB"
			})]
		})] })
	]
});
export { SvgBoolean as ReactComponent };
